import { AccordionDetails } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { tesaBlue } from "../../styles/colors";

const useStyles = makeStyles({
  accordionRoot: {
    marginTop: "0px",
    "&:before": {
      height: "0px",
    },
    "&.Mui-expanded": {
      marginTop: 0,
    },
  },
  detailsRoot: {
    display: "block",
    padding: 0,
  },
  summaryRoot: {
    marginTop: 0,
    minHeight: 0,
    padding: 0,
    "& .MuiAccordionSummary-content": {
      color: tesaBlue,
      fontFamily: "Proxima Nova Bold",
      fontWeight: 500,
      marginTop: 0,
    },
    "&.Mui-expanded": {
      minHeight: 0,
    },
    width: "fit-content",
  },
});

interface StyledAccordionProps {
  children: JSX.Element | JSX.Element[];
  expanded: boolean;
  summary?: string | JSX.Element;
  toggleExpanded: () => void;
}

function StyledAccordion(props: StyledAccordionProps) {
  const { children, expanded, summary, toggleExpanded } = props;
  const classes = useStyles();

  return (
    <Accordion classes={{ root: classes.accordionRoot }} expanded={expanded} onChange={toggleExpanded} square>
      <AccordionSummary classes={{ root: classes.summaryRoot }} style={{ display: summary ? "block" : "none" }}>
        {summary}
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.detailsRoot }}>{children}</AccordionDetails>
    </Accordion>
  );
}

export default StyledAccordion;
